import { Navigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { ControlCreationOptions } from "./components/ControlCreationOptions";
import { useOptroBulkImportEnabled } from "../../../hooks/useOptroBulkImportEnabled";
import { useFeatureFlagsReady } from "../../../contexts/launchDarklyContext";

// Landing page for "Create New Control": the same entry cards as the
// controls list's empty state. The manual/AI creation form lives one step
// deeper at /audit/controls/v2/create/manual. With Optro bulk import off the
// chooser would hold a single card, so skip it and go straight to the form.
export const CreateControlChooserPage = () => {
  const flagsReady = useFeatureFlagsReady();
  const optroBulkImportEnabled = useOptroBulkImportEnabled();
  // On a cold load the flag reads its fail-closed default (false) until
  // LaunchDarkly resolves — redirecting on that would bounce an entitled
  // user to the manual form with no way back but reload.
  if (!flagsReady) {
    return (
      <div className="h-screen flex justify-center items-center">
        <Loader2 className="h-6 w-6 animate-spin text-stone-400" />
      </div>
    );
  }
  if (!optroBulkImportEnabled) {
    return <Navigate to="/audit/controls/v2/create/manual" replace />;
  }
  return (
    <div className="h-screen overflow-y-auto w-full px-6">
      <ControlCreationOptions
        title="Create New Controls"
        subtitle="Bulk import from Optro, or build controls yourself. Most of your control data already lives in Optro and carries over automatically."
      />
    </div>
  );
};

export default CreateControlChooserPage;
